function setHeartActive(btn, isActive) {
  const path = btn.querySelector('.wishlist-heart-path');
  if (!path) return;

  const isCard = btn.classList.contains('wishlist-button--card');
  const inactiveColor = isCard ? '#FED1DB' : '#91425F';
  const activeColor = '#D54C6A';

  if (isActive) {
    btn.classList.add('active');
    path.setAttribute('fill', activeColor);
    path.setAttribute('stroke', activeColor);
  } else {
    btn.classList.remove('active');
    path.setAttribute('fill', inactiveColor);
    path.setAttribute('stroke', 'none');
  }
}

async function checkWishlistStatus(productId, btn) {
  // If we already have preloaded data, we might not need this,
  // but keeping it for cases where preloaded data is missing or for guests if supported.
  try {
    const response = await fetch('/apps/wishlist/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: 'gid://shopify/Product/' + productId,
        action: 'check',
      }),
    });

    if (response.ok) {
      const data = await response.json();
      if (data.isInWishlist) {
        setHeartActive(btn, true);
      }
    }
  } catch (error) {
    console.error('Error checking wishlist status:', error);
  }
}

async function toggleWishlist(btn) {
  if (!window.isCustomerLoggedIn) {
    window.location.href = '/account/login';
    return;
  }

  const productId = btn.getAttribute('data-product-id');
  const isActive = btn.classList.contains('active');
  const action = isActive ? 'remove' : 'add';

  // Optimistic Update
  setHeartActive(btn, !isActive);

  const productTitle = btn.getAttribute('data-product-title') || 'Product';

  // Animation
  btn.style.transform = 'scale(1.3)';
  setTimeout(() => {
    btn.style.transform = 'scale(1)';
  }, 150);

  try {
    const response = await fetch('/apps/wishlist/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: 'gid://shopify/Product/' + productId,
        action: action,
      }),
    });

    if (response.status === 401) {
      window.location.href = '/account/login';
      return;
    }

    if (!response.ok) {
      throw new Error('Request failed');
    }

    const toastMessages = {
      add: productTitle + ' added to wishlist',
      remove: productTitle + ' removed from wishlist'
    };
    window.BakedBeautyToast && window.BakedBeautyToast.show(toastMessages[action], action === 'add' ? 'success' : 'remove');
  } catch (error) {
    console.error('Toggle failed:', error);
    // Revert UI on failure
    setHeartActive(btn, isActive);
  }
}

function initWishlistButtons() {
  const wishlistBtns = document.querySelectorAll('.wishlist-button');
  if (wishlistBtns.length === 0) return;

  const preloadedWishlist = window.customerWishlist || [];
  const isLoggedIn = window.isCustomerLoggedIn;

  wishlistBtns.forEach((btn) => {
    const productId = btn.getAttribute('data-product-id');
    if (!productId) return;

    const gid = 'gid://shopify/Product/' + productId;

    if (isLoggedIn) {
      if (preloadedWishlist.includes(gid)) {
        setHeartActive(btn, true);
      } else {
        setHeartActive(btn, false);
      }
    } else {
      // For guests, we check status via API (if the app supports guest wishlists)
      checkWishlistStatus(productId, btn);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistButtons, { once: true });
} else {
  initWishlistButtons();
}
